import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { Action } from "shared/types/Action"
import { ProjectChildMultiActionCallbacks } from "shared/types/ProjectChild"
import { IconName } from "shared/ui/icon/__generated__/IconName"

export interface UseProjectChildMultiActionsArgs
  extends Partial<ProjectChildMultiActionCallbacks> {
  isDeleteDisabled?: boolean
}

export function useProjectChildMultiActions({
  onDelete,
  isDeleteDisabled
}: UseProjectChildMultiActionsArgs) {
  const { t } = useTranslation()

  const deleteAction: Action = useMemo(
    () => ({
      id: "project-child__multi-actions__delete",
      icon: IconName.BIN,
      label: t("ProjectChild.Actions.Delete"),
      isDanger: true,
      disabled: isDeleteDisabled,
      onClick: onDelete
    }),
    [isDeleteDisabled, onDelete]
  )

  const actions: Action[] = useMemo(
    () => [deleteAction].filter(action => !!action.onClick),
    [deleteAction]
  )

  return {
    actions,
    deleteAction
  }
}
